import { Box, Button, Chip, Container, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import SRI_pagination from "../components/pagination/pagination";
import FooterBar from "../footer/footerBar";
import { Add, Close, CloseOutlined, Search } from "@mui/icons-material";
import Navbar from "../navbar/navbar";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";


function Unidade() {

    const [showModal, setShowModal] = useState(false);
const [modoEdicao, setModoEdicao] = useState(false);
const [unidades, setUnidades] = useState([]);
const [texto, setTexto] = useState("");
const [busca, setBusca] = useState("");
const [nPag, setnPag] = useState(1);
const [totalPaginas, setTotalPaginas] = useState(1);

const [cod, setCod] = useState("");
const [descricao, setDescricao] = useState("");
const [idCatalogo, setIdCatalogo] = useState("");
const [att, setAtt] = useState(false);

let config = {
           headers: {
         'Authorization': localStorage.getItem("token")
         }
      }

useEffect(function(){
        api.post(vhostV1('webcash/unidades/listar'),{
            busca: busca,
            pagina: nPag,
            regPag: 10
        },config)
        .then(function(response){
            console.log(response);
            
            
            if(response.data.result === 1){
                
                setTotalPaginas(response.data.quantidadePagina);
                setUnidades(response.data.dados);
                
            }

            
        }).catch(function(err){
            console.log(err);
            
        })
     },[busca, nPag, att]);


          function handlePageChange(value){
      if(value === "&laquo;" || value === '... '){
        setnPag(1);
      }else if (value === "&lsaquo;" ){
        if (nPag !== 1){
          setnPag(nPag -1);
        }
      }else if(value === "&rsaquo;"){
        setnPag(nPag +1);        
      }else if(value === "&raquo;" || value === ' ...' ){
        setnPag(totalPaginas);        
      }else{
        setnPag(value);
      }    
     
     }

const handleNovo = () => {
  setModoEdicao(false);

  setCod("");
  setDescricao("");
  setIdCatalogo("");

  setShowModal(true);
};

const handleEditar = (item) => {
  setModoEdicao(true);

  setCod(item.COD);
  setDescricao(item.DESCRICAO);
  setIdCatalogo(item.ID_CATALOGO);

  setShowModal(true);
};

const fecharModal = () => {
  setShowModal(false);
};

const salvarUnidade = () => {
  
        api.post(vhostV1('webcash/unidades/inclui'),{
            COD: cod,
            DESCRICAO: descricao,
            ID_CATALOGO: Number(idCatalogo)
        },config)
        .then(function(response){
            console.log(response);
            
            setShowModal(false);
            setAtt(!att);

            
        }).catch(function(err){
            console.log(err);
            
        })
};

return (
  <div>
    <Navbar />

    <Container maxWidth="lg">
      <Box my={4}>
        {/* Título */}
        <Box mt={5} mb={3} pt={5}>
          <Typography variant="h4" sx={{ color: "primary.main" }}>
            Lista de Unidades
          </Typography>
        </Box>

        {/* Botão + Pesquisa */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
          mb={2}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<Add />}
              onClick={handleNovo}
              sx={{ boxShadow: 3 }}
            >
              Adicionar Unidade
            </Button>

            <Chip
              label={`Total Unidades: ${unidades.length}`}
              color="primary"
              sx={{
                height: 33,
                borderRadius: 2,
                px: 2,
                "& .MuiChip-label": {
                  fontSize: "1.1rem",
                  padding: 0,
                },
              }}
            />
          </Box>

          <TextField
            variant="outlined"
            label="Pesquisar"
            value={texto}
            onChange={(e) => setTexto(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setBusca(texto)}
                    color="primary"
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              flexGrow: 1,
              minWidth: 250,
              maxWidth: 500,
              "& .MuiOutlinedInput-root": { height: 50 },
              "& .MuiInputLabel-root": { fontSize: "1.2rem" },
              "& .MuiInputBase-input": { fontSize: "1.1rem" },
            }}
          />
        </Box>

        {/* Tabela */}
        <TableContainer
          component={Paper}
          sx={{ boxShadow: 3, borderRadius: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  Código
                </TableCell>

                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  Descrição
                </TableCell>

                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  ID Catálogo
                </TableCell>

                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {unidades.map((item) => (
                <TableRow key={`${item.COD}-${item.ID_CATALOGO}`}>
                  <TableCell align="center">
                    {item.COD}
                  </TableCell>

                  <TableCell align="center">
                    {item.DESCRICAO}
                  </TableCell>

                  <TableCell align="center">
                    {item.ID_CATALOGO}
                  </TableCell>

                  <TableCell align="center">
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => handleEditar(item)}
                    >
                      Editar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Modal Adicionar / Editar */}
        <Dialog
          open={showModal}
          onClose={fecharModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">
              {modoEdicao ? "Editar Unidade" : "Nova Unidade"}
            </Typography>

            <IconButton onClick={fecharModal}>
              <CloseOutlined />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Código"
                  value={cod}
                  onChange={(e) => setCod(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Descrição"
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                  fullWidth
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="ID Catálogo"
                  value={idCatalogo}
                  onChange={(e) => setIdCatalogo(e.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>
          </DialogContent>

          <DialogActions>
            <Button onClick={fecharModal}>
              Cancelar
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={salvarUnidade}
            >
              Salvar
            </Button>
          </DialogActions>
        </Dialog>

        <Box mt={5}>
          <SRI_pagination
            totalPage={totalPaginas}
            page={nPag}
            limit={10}
            siblings={1}
            onPageChange={handlePageChange}
          />
        </Box>
      </Box>
    </Container>

    <FooterBar />
  </div>
);
}
export default Unidade;